module.exports = __webpack_public_path__ + "static/stunners-home-ad321f1598e36afa95a621fca7966e72.png";